import { Component, h, State } from '@stencil/core';
import Helmet from '@stencil/helmet';

import URLS from '../app-root/urls';
const pageInfo = {
  pageURL: URLS.AppContactPage,
  pageTitle: 'Kontakt - ZENTO Magento 2 PWA SaaS',
  pageDescription: "",
  keywords: "ecommerce paltform, online store, create website, online shop, magento, gentoshop",
  ogimage: 'assets/icon/var_og-image.png'
};

@Component({
  tag: 'app-contact-page',
  styleUrl: 'style.scss',
  shadow: false,
  scoped: false
})
export class AppContactPage {
  static pageURL = '/contact-page';
  static companies = [
    {
      company: "Blugento S.A.",
      address: {
        street: "Henri Barbusse, 44-46",
        city: "Cluj-Napoca",
        province: "Cluj",
        country: "Romania",
        postcode: "400616"
      },
      traderegistry: "J12/1919/2016",
      vat: "RO36072180"
    },
    {
      company: "ZentoShop Sp. z o.o.",
      address: {
        street: "ul. Franklina Roosevelta 22",
        city: "Poznań",
        province: null,
        country: "Poland",
        postcode: "60-829"
      }
    }
  ];

  @State() formControls = {
    name: {
      value: null,
      validate: value => {
        if (value) {
          return true;
        } else {
          return false;
        }
      },
      isValid: null
    },
    email: {
      value: null,
      validate: value => {
        if (value) {
          return true;
        } else {
          return false;
        }
      },
      isValid: null
    },
    telephone: {
      value: null,
      validate: value => {
        if (value) {
          return true;
        } else {
          return false;
        }
      },
      isValid: null
    },
    comment: {
      value: null,
      validate: value => {
        if (value) {
          return true;
        } else {
          return false;
        }
      },
      isValid: null
    },
  };
  @State() submitted = null;
  @State() showSubmitMessage = false;
  @State() UE: Function;
  @State() userengage: Function;
  @State() terms: boolean = null;

  // Once form is loaded we start validate all fields
  componentDidLoad() {
    // Set up name validate function
    this.formControls.name.validate = value => {
      if (value && value.length > 3) {
        return true;
      } else {
        return false;
      }
    };

    // Set up email validate function
    this.formControls.email.validate = value => {
      if (value && value.length > 6) {
        return true;
      } else {
        return false;
      }
    };

    // Set up telephone validate function
    this.formControls.telephone.validate = value => {
      if (value && value.length > 6) {
        return true;
      } else {
        return false;
      }
    };

    // Set up comment validate function
    this.formControls.comment.validate = value => {
      if (value && value.length > 2) {
        return true;
      } else {
        return false;
      }
    };
  }

  // Once inputs value is changing we start validate fields
  changeFormValue(controlName, value) {
    this.formControls = {
      ...this.formControls,
      [controlName]: {
        ...this.formControls[controlName],
        value: value,
        isValid: this.formControls[controlName].validate(value)
      }
    };
  }

  // Validate terms checkbox
  changeTerms(event: any) {
    this.terms = event.target.checked;
  }

  // Validate fields if value doesn't coincide
  validateFields() {
    this.submitted = false;

    if (this.formControls.name.value === null ||
      this.formControls.name.value === '') {
      this.formControls.name.isValid = false;
    }

    if (this.formControls.telephone.value === null ||
      this.formControls.telephone.value === '') {
      this.formControls.telephone.isValid = false;
    }

    if (this.formControls.email.value === null ||
      this.formControls.email.value === '') {
      this.formControls.email.isValid = false;
    }

    if (this.formControls.comment.value === null ||
      this.formControls.comment.value === '') {
      this.formControls.comment.isValid = false;
    }
  }

  /**
   * Fetch form url submit response
   */
  async handleSubmit(e) {
    e.preventDefault();

    // Send data to our url
    const data = {
      name: this.formControls.name.value,
      email: this.formControls.email.value,
      telephone: this.formControls.telephone.value,
      comment: this.formControls.comment.value,
    }

    const formData = new FormData()
    for(const name in data) {
      formData.append(name, data[name]);
    }

    if (this.terms) {
      fetch(process.env.BASEURL + 'api/form/contact', {
        method: 'POST',
        body: formData,
      })
      .then(response => response.json())
      .then((data) => {
        let isFormValid = true;
        this.submitted = true;

        if (data.result) {
          this.showSubmitMessage = true;

          (this.UE as any).pageHit({
            apiKey: process.env.USERCHAT,
            first_name: this.formControls.name.value,
            phone_number: this.formControls.telephone.value,
            email: this.formControls.email.value,
          });

          (this.userengage as any)('event.Submitted Form', {
            apiKey: process.env.USERCHAT,
            first_name: this.formControls.name.value,
            phone_number: this.formControls.telephone.value,
            email: this.formControls.email.value,
          });

          if (isFormValid) {
            this.formControls.name.isValid = false;
            this.formControls.telephone.isValid = false;
            this.formControls.email.isValid = false;

            this.changeFormValue('name', '');
            this.changeFormValue('email', '');
            this.changeFormValue('telephone', '');
            this.changeFormValue('comment', '');
            this.changeFormValue('terms', false);

            this.submitted = false;
            isFormValid = false;
          }
        } else {
          this.showSubmitMessage = false;

          this.validateFields();

          // Run all validation functions
          for (let controlName in this.formControls) {
            let control = this.formControls[controlName];
            control.validate(control.value);

            if (!control.isValid) {
              isFormValid = false;
            }
          }
        }
      })
      .catch((item) => {
        if (!item.result) {
          for(const error in item.errors) {
            console.log('Please provide a value for ' + item.errors[error].field);
          }
        }
      });
    } else {
      this.terms = false;
      this.submitted = false;

      this.validateFields();
    }
  }

  componentDidRender() {
    document.title = pageInfo.pageTitle;
    document.querySelector('meta[name="Description"]').setAttribute('content', pageInfo.pageDescription);
    document.querySelector('meta[property="og:description"]').setAttribute('content', pageInfo.pageDescription);
  }
  render() {
    return (
      <div class='app-contact-page'>
        <Helmet>
          <title>{pageInfo.pageTitle}</title>
          <meta name="Description" content={pageInfo.pageDescription} />
          <meta name="keywords" content={pageInfo.keywords} />
          <meta property="og:description" content={pageInfo.pageDescription} />
          <meta property="og:image" content={process.env.BASEURL + pageInfo.ogimage} />
          <meta property="og:site_name" content="ZENTO" />
          <meta property="og:title" content={pageInfo.pageTitle} />
          <meta property="og:type" content="website" />
          <meta property="og:url" content={process.env.BASEURL + pageInfo.pageURL.substr(1,pageInfo.pageURL.length)} />
        </Helmet>

        <div class='contact-wrapper'>
          <app-contact-form
            class='contact-form'
          />

          <div class='contact-page-info'>
            { AppContactPage.companies.map(c => {
              return <div class='address'>
                <h2>{ c.company }</h2>
                <p>{ c.address.street }</p>
                <p>
                  { c.address.city+', ' }
                  { c.address.province ? c.address.province+', ' : '' }
                  { c.address.postcode ? c.address.postcode+', ' : '' }
                  { c.address.country }
                </p>
                { c.vat
                  ? <p>VAT code: { c.vat }</p>
                  : ''
                }
              </div>;
            })}
            <div class='contact-mail'>
              <p>
                <a href='mailto:contact@zentoshop.com'>contact@zentoshop.com</a>
              </p>
            </div>
          </div>
          <div class='map'>
            <iframe height="480" src="https://www.google.com/maps/d/u/0/embed?mid=1iXXhfB0zSn32M9fp2piPvFhYyJl5PQRu" width="100%"></iframe>
          </div>
        </div>
      </div>
    );
  }
}
